import {
    MediaProgramWithGuides,
    MediaProgramMetadata,
} from '@/utils/media/types';
import { getProgramId } from '@/utils/programs';
import { WorkflowWorkflowInfo } from '@calm/evexia-web-sdk';
import { ProgramProvider } from '@rhg/providers/program';
import { ContextAwareProgram } from './context-aware';
import { ShuffleArmProvider } from './shuffle-arm';

export interface ProgramProps {
    program: MediaProgramWithGuides;
    packClass: string | undefined;
    packProgram?: MediaProgramMetadata;
    workflow?: WorkflowWorkflowInfo;
    showOverview?: boolean;
}
export function Program({
    program,
    packProgram,
    packClass,
    workflow,
    showOverview,
}: ProgramProps) {
    return (
        <ProgramProvider
            program={program}
            packClass={packClass}
            packProgram={packProgram}
            workflow={workflow}
        >
            {/* programId drives an internal reset of the armed-shuffle intent
                when navigating between programs (EVE-13091) — no `key`, so the
                program view is not remounted. */}
            <ShuffleArmProvider programId={getProgramId(program)}>
                <ContextAwareProgram showOverview={showOverview} />
            </ShuffleArmProvider>
        </ProgramProvider>
    );
}
